import { SCENE_H, SCENE_W } from "@squire/sprites";

/** Create the scene canvas and keep it at the largest scale that fits its host (integer from 2x up). */
export function createSceneCanvas(host: HTMLElement): {
  canvas: HTMLCanvasElement;
  ctx: CanvasRenderingContext2D;
  dispose: () => void;
} {
  const canvas = document.createElement("canvas");
  canvas.width = SCENE_W;
  canvas.height = SCENE_H;
  canvas.className = "scene";
  host.appendChild(canvas);
  const ctx = canvas.getContext("2d", { alpha: false })!;
  ctx.imageSmoothingEnabled = false;

  const fit = () => {
    // Integer scale keeps pixels crisp; below 2x (small phones) a fractional fit beats a tiny scene.
    const fitScale = Math.min(host.clientWidth / SCENE_W, host.clientHeight / SCENE_H);
    const scale = fitScale >= 2 ? Math.floor(fitScale) : Math.max(1, Math.floor(fitScale * 8) / 8);
    canvas.style.width = `${SCENE_W * scale}px`;
    canvas.style.height = `${SCENE_H * scale}px`;
    canvas.dataset.scale = String(scale);
  };
  fit();
  const ro = new ResizeObserver(fit);
  ro.observe(host);
  return { canvas, ctx, dispose: () => ro.disconnect() };
}
